// Start Gallery Slider
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".gallery-slider-section .section-content-wrapper");
  if (!section) return;

  const track = section.querySelector(".gallery-track");
  if (!track) return;

  const clone = track.cloneNode(true);

  const wrapper = document.createElement("div");
  wrapper.className = "gallery-wrapper";

  const parent = track.parentElement;
  parent.insertBefore(wrapper, track);

  wrapper.appendChild(track);
  wrapper.appendChild(clone);

  requestAnimationFrame(() => {
    const singleWidth = track.scrollWidth;
    const speed = 60;
    const duration = singleWidth / speed;
    wrapper.style.animation = `scrollLeft ${duration}s linear infinite`;
  });
});

  document.addEventListener("DOMContentLoaded", function () {
    const button = document.querySelector(".enquiry-form-button");
    const form = document.querySelector(".enquiry-form");

    if (button && form) {
      button.addEventListener("click", function () {
        form.style.display = "block";
      });
    }
  });

  const whatsappButton = document.getElementById("whatsappButton");

let scrollTimeout;

window.addEventListener("scroll", function () {

    // Hide immediately while scrolling
    whatsappButton.classList.add("hide");

    // Reset timer
    clearTimeout(scrollTimeout);

    // Show after 2 seconds of no scrolling
    scrollTimeout = setTimeout(function () {
        whatsappButton.classList.remove("hide");
    }, 2000);

});

// Show button on page load
window.addEventListener("load", function () {
    whatsappButton.classList.remove("hide");
});